// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { PageTitle, TeamHeader } from "react-fast-ui";
import join from "url-join";
import { replaceHash } from "replace-hash";
import PropTypes from "prop-types";

import LoadingDiv from "./layout/LoadingDiv";
import { ACCOUNT_DETAILS, ACCOUNT_USERS_PATH } from "./AdminRouter";
import NavigationLayout from "./NavigationLayout";
import LinkTabs, { Tab } from "./layout/LinkTabs";
import AccountSummaryPage from "./AccountSummaryPage";
import AccountUsersPage from "./AccountUsersPage";
import Session from "../Session";
import Cache from "../Cache";
import Team from "../models/Team";
import actions from "../actions/actionTypes";
import UpgradeConsumerModal from "./UpgradeConsumerModal";

const LOADING = <LoadingDiv>Loading Admin Portal...</LoadingDiv>;

const mapStateToProps = (store) => ({
  leagueId: store.leagueId,
  team: store.team,
});

if (typeof recharge !== "undefined") {
  recharge.init({
    storeIdentifier: "fastmodel-sports.myshopify.com",
    storefrontAccessToken:
      "strfnt_ef5b237464669df5241579c884806b83ce9db2d808bc0931546e060f66c88d8e",
  });
}

class AdminPortalRootPage extends Component {
  static contextTypes = {
    contentWidth: PropTypes.number,
    dao: PropTypes.object.isRequired,
    onError: PropTypes.func,
    router: PropTypes.object.isRequired,
    session: PropTypes.instanceOf(Session),
    ngUser: PropTypes.object,
  };

  static Tabs = ({ selectedKey, primaryColor }) => {
    return (
      <LinkTabs selectedKey={selectedKey} primaryColor={primaryColor}>
        <Tab
          href={join("admin", ACCOUNT_USERS_PATH)}
          tabKey={ACCOUNT_USERS_PATH}
          label="ACCOUNT USERS"
          className="color-medium-gray"
        />
        <Tab
          href={join("admin", ACCOUNT_DETAILS)}
          tabKey={ACCOUNT_DETAILS}
          label="ACCOUNT DETAILS"
          className="color-medium-gray"
        />
      </LinkTabs>
    );
  };

  state = {
    loadingUserTeam: (null: ?Promise),
  };

  state = {
    loadingUserTeam: null,
    showUpgradeModal: false,
    payload: null,
    customerPortalUrl: "",
    requestInProgress: false,
  };
  // Methods to update state
  setOpenUpgradeConsumerModal = (value) => {
    this.setState({ showUpgradeModal: value });
  };

  setPayload = (payload) => {
    this.setState({ payload });
  };

  setCustomerPortalUrl = (url) => {
    this.setState({ customerPortalUrl: url });
  };

  componentWillMount() {
    if (Cache.getUserRequestedHref()) {
      const path = Cache.getUserRequestedHref();
      Cache.clearUserRequestedHref();
      this.props.router.replace(path);
    }
  }

  componentDidMount() {
    const { session, onError } = this.context;

    // urls saved before we switched from browserHistory to hashHistory will still work
    replaceHash();
    this.loadInfo();

    if (session.hasErrorToShow()) {
      setTimeout(() => onError(session.popErrorToShow(), 3000));
    }
  }

  loadInfo() {
    const { dao, onError, ngUser } = this.context;
    const { dispatch } = this.props;
    const { loadingUserTeam: userTeamPromise } = this.state;

    if (userTeamPromise) userTeamPromise.cancel();
    if (ngUser.isConsumer == "true" || ngUser.leagueId === null) {
      const team = new Team({
        colorPrimary: ngUser.primaryColor,
        colorSecondary: ngUser.secondaryColor,
        abrv: ngUser.teamAbrv,
        id: ngUser.teamId,
        name: ngUser.teamName,
        nick: ngUser.teamNick,
        links: [{ rel: "logo", href: ngUser.teamLogo }],
      });
      dispatch({ type: actions.GET_USER_TEAM_SUCCESS, team });
      this.setState({ loadingUserTeam: Promise.resolve() });
    } else {
      if (ngUser.teamId) {
        const loadingUserTeam = dao.teams
          .getUserTeam(ngUser.teamId)
          .then((team) => {
            dispatch({ type: actions.GET_USER_TEAM_SUCCESS, team });
          })
          .catch(onError);
        this.setState({ loadingUserTeam });
      }
    }
  }

  render() {
    const {
      team,
      containerWidth,
      router: {
        params: { view: viewId },
      },
    } = this.props;
    const {
      loadingUserTeam,
      showUpgradeModal,
      customerPortalUrl,
      payload,
      requestInProgress,
    } = this.state;
    const { dao, ngUser, session } = this.context;

    const loadingInfo = !loadingUserTeam || _.isEmpty(team);

    // check if consumer
    if (
      ngUser.isConsumer == "true" &&
      (ngUser.leagueId === null || ngUser.leagueId === "C-UNK") &&
      !requestInProgress &&
      !payload
    ) {
      this.setState({ requestInProgress: true });
      // check if eligibile
      dao.account.getIsUpgradeEligible().then((isUpgradable) => {
        // get payload
        if (isUpgradable) {
          dao.account.getRechargeUpgradePayload().then((res) => {
            this.setPayload(res);
            recharge.customer
              .getCustomerPortalAccess(res.session)
              .then((rechargeRes) => {
                this.setCustomerPortalUrl(rechargeRes.portal_url);
                this.setOpenUpgradeConsumerModal(isUpgradable);
                this.setState({ requestInProgress: false });
              });
          });
        }
      });
    }

    return (
      <PageTitle title="FastModel User Portal">
        {loadingInfo ? (
          LOADING
        ) : (
          <NavigationLayout className="display-flex flex-direction-column flex-grow-1">
            <TeamHeader
              containerWidth={containerWidth}
              primaryColor={team.getPrimaryColor()}
              fullName={team.getFullName()}
              logo={team.getLogoHref()}
              className="hidden-print"
            >
              <AdminPortalRootPage.Tabs
                selectedKey={viewId}
                primaryColor={team.getPrimaryColor()}
              />
            </TeamHeader>
            {viewId === ACCOUNT_USERS_PATH ? (
              <AccountUsersPage featureFlags={this.props.featureFlags} />
            ) : (
              <AccountSummaryPage />
            )}
            <UpgradeConsumerModal
              dao={dao}
              open={showUpgradeModal}
              onClose={() => setOpenUpgradeConsumerModal(false)}
              upgradeLink={customerPortalUrl}
              payload={payload}
              logout={session.logout}
            />
          </NavigationLayout>
        )}
      </PageTitle>
    );
  }
}

export default connect(mapStateToProps)(AdminPortalRootPage);
